module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6156ddbd0164c7960a2d4c4f96f7342.png";